// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'documents-solid';

export const Component = () => (
  <path d='M5.928 22.558h13.745v.479c0 .431-.143.766-.43 1.054a1.408 1.408 0 0 1-1.055.43H3.485a1.41 1.41 0 0 1-1.054-.43A1.408 1.408 0 0 1 2 23.037V4.407c0-.432.144-.767.431-1.055a1.408 1.408 0 0 1 1.054-.43h.48v17.672c0 .526.19 1.005.574 1.389a1.92 1.92 0 0 0 1.39.575ZM22.26 5.89h-5.076c-.336 0-.48-.143-.48-.479V.288l5.556 5.603Zm-5.077.958h5.412v13.267c0 .43-.144.766-.432 1.054a1.408 1.408 0 0 1-1.054.43H6.406a1.41 1.41 0 0 1-1.054-.43 1.408 1.408 0 0 1-.43-1.054V1.486c0-.432.143-.767.43-1.055A1.408 1.408 0 0 1 6.406 0h9.292l.047 5.412c0 .383.144.718.383 1.054.335.239.67.382 1.054.382v.001Z' />
);

export const viewBox = '0 0 25 25';
